export const aciTrips = {
    iconName: 'trips',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M20.168 3.417c-.157.043-15.501 5.046-15.655 5.105a1.633 1.633 0 00.027 3.034c.081.03 1.706.427 3.609.884l3.46.83.834 3.468c.46 1.908.854 3.52.876 3.585.183.518.669.928 1.224 1.035a1.643 1.643 0 001.773-.88c.066-.134 5.114-15.607 5.161-15.821.112-.513-.194-1.04-.706-1.22a1.158 1.158 0 00-.603-.02zm-7.945 3.615a1687.17 1687.17 0 00-7.38 2.417.746.746 0 00-.292.293c-.16.32-.02.734.3.879.053.024 1.654.417 3.556.873l3.46.83 3.838-3.839c2.112-2.11 3.835-3.838 3.83-3.837-.006 0-3.296 1.073-7.313 2.384zm4.168 2.151l-3.834 3.835.838 3.481c.46 1.915.855 3.517.877 3.56a.747.747 0 00.313.29.656.656 0 00.827-.258c.025-.044 1.09-3.285 2.365-7.202 2.539-7.795 2.456-7.54 2.452-7.54 0 0-1.728 1.725-3.837 3.834z',
                fill: 'currentColor',
            },
        },
    },
};
